const user = (state = null, action) => {
  switch (action.type) {
    case 'user/login':
      return action.payload || state
    case 'user/logout':
      return null
    default:
      return state
  }
}

export default user
